/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

// Same-origin path the swift server proxies to the Vinyl logger (GH parity).
const VINYL_LOG_PROXY_PATH = '/api/vinyl/log'

/**
 * Vinyl error-logging endpoint for the active auth mode. Cookie-session
 * (AuthPortal) posts logs same-origin so the swift server proxies them with the
 * first-party session cookie attached — a cross-origin Vinyl logger host would
 * drop the cookie. Bearer builds keep Vinyl's own logger endpoint (the token
 * rides the request, not a cookie).
 */
export function selectErrorLoggingEndpoint(params: {
    cookieAuth: boolean
    pageOrigin: string
    defaultEndpoint: string
}): string {
    const { cookieAuth, pageOrigin, defaultEndpoint } = params
    return cookieAuth ? `${pageOrigin}${VINYL_LOG_PROXY_PATH}` : defaultEndpoint
}
